module.exports = __webpack_public_path__ + "img/type_ROCK.92dd1da2.png";